import { Observable } from "rxjs";
import PoolData from "./RandomsModel/PoolData"
import PoolCreate from "./RandomsModel/PoolCreate"
import { format, parseISO } from "date-fns"
import { ObservableFromFetch } from "../ObservableFromFetch"

export function PoolUpdateObservable(data: PoolData, IsConsortium: boolean): Observable<string> {
  const params: string = JSON.stringify({
    IsDOT: data.DOT,
    RegulatoryModeID: data.RegulatoryModeID,
    SelectionInterval: data.SelectionInterval,
    DrugTarget: data.DrugSampleSize,
    AlcoholTarget: data.AlcoholSampleSize,
    ProviderMappingID: data.ProviderMappingID,
    PanelID: data.PanelID,
    PoolCalculationType: data.FixedOrRate,
    Code: data.Code,
    PoolID: data.PoolID,
    PoolName: data.Name,
    UseFileImportForPoolMembership: data.UseFileImportForPoolMembership,
    DateFrom: format(parseISO(data.ProgramIntervalStartDate), "MM/dd/yyyy"),
    DateTo: format(parseISO(data.ProgramIntervalEndDate), "MM/dd/yyyy"),
    PrimaryIDType: data.PrimaryIDType || "",
    IncludeCompaniesWithNoSelections: data.IncludeCompaniesWithNoSelections,
    IsConsortium: IsConsortium,
    PanelCode: data.PanelCode,
    RegulatoryModes: data.RegulatoryModes,
    RunOnlyByPortalAdmin: data.RunOnlyByPortalAdmin
  })

  return ObservableFromFetch<string>("FFOrderPoolDefinition/UpdatePool", params)
}

export function PoolCreateObservable(data: PoolCreate): Observable<string> {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("FFOrderPoolDefinition/CreatePool", params)
}
